<template>
    <div id="application">
        <main-menu></main-menu>
        <router-view></router-view>
    </div>
</template>

<script>
    import MainMenu  from './components/main-menu';
    import Vue       from 'vue';
    import Router    from './router.js';
    import Store     from './store.js';
    import User      from './user.js';
    import Axios     from 'axios';

    Vue.prototype.$http = Axios;
    Vue.prototype.$user = User;

    export default
    {
        name:   'Application',
        router: Router,
        store:  Store,
        components: {
            MainMenu
        },
        beforeCreated: onBeforeCreate,
        created:       onCreated,
        beforeMount:   onBeforeMount,
        mounted:       onMounted,
        beforeUpdate:  onBeforeUpdate,
        updated:       onUpdated,
        beforeDestroy: onBeforeDestroy,
        destroyed:     onDestroyed,
        render:        onRender
    }

    function onBeforeMount()
    {
        console.log( 'application onBeforeMount' );
    }

    function onMounted()
    {
        console.log( 'application onMounted.' );
    }

    function onCreated()
    {
        console.log( 'application onCreated.' );
    }

    function onBeforeCreate()
    {
        console.log( 'application onBeforeCreate.' );
    }

    function onBeforeUpdate()
    {
        console.log( 'application onBeforeUpdate' );
    }

    function onUpdated()
    {
        console.log( 'application onUpdated' );
    }

    function onBeforeDestroy()
    {
        console.log( 'application onBeforeDestroy' );
    }

    function onDestroyed()
    {
        console.log( 'application onDestroyed' );
    }

    function onRender()
    {
        console.log( 'application onRender.' );
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/application.vue